import Link from 'next/link';
import 'react-phone-input-2/lib/style.css';

import { createMarkup } from 'app/scripts/utils';
import { useWindowWidth } from 'app/scripts/useWindowWidth';

import Container from './Container';
import ContactForm from './ContactForm';
import ContactTrustedClient from './ContactTrustedClient';
export default function HeroForContact({
  data,
  clientlogo,
  setModalCall = false,
}) {
  const windowWidth = useWindowWidth();
  return (
    <div
      className="relative bg-cover bg-no-repeat bg-center h-full"
      style={{
        backgroundImage: `${data?.bgImage ? `url(${data?.bgImage?.data?.attributes?.url})` : ``}`,
      }}
    >
      <Container className="lg:px-0 lg:mr-0 lg:max-w-[100%_!important]">
        <div className="grid lg:grid-cols-12 grid-cols-6">
          <div className={`col-span-6`}>
            <div className="lg:py-[70px] md:py-[40px] py-[30px] lg:ml-[50px]">
              {data?.titleEditor && (
                <div
                  className="bannerfont font-[400] xl:text-[60px] md:text-[32px] text-[26px] title_hd lg:leading-[75px] mb-4 leading-tight"
                  dangerouslySetInnerHTML={createMarkup(data?.titleEditor)}
                ></div>
              )}
              {data?.h1_purple && (
                <h6 className="mb-3 text-[24px] font-[400] text-[#FFFFFF]">
                  {data?.h1_purple}
                </h6>
              )}
              {data?.h1_black && (
                <h1 className="lg:text-[50px] text-[#ffffff] md:text-[32px] text-[27px] font-[800] lg:mb-3 mb-2 leading-tight">
                  {data?.h1_black}
                </h1>
              )}
              {data?.p && (
                <p className="xl:text-[30px] lg:text-[24px] text-[18px] font-[600] text-[#FFFFFFE5] lg:mb-4 mb-2 leading-tight">
                  {data?.p}
                </p>
              )}
              {data?.description && (
                <p className="text-[#FFFFFF] xl:text-[20px] lg:text-[17px] text-[14px] font-[400] leading-tight">
                  {data?.description}
                </p>
              )}
              <div className="flex flex-wrap items-center lg:mt-8 mt-5">
                {data?.banner_btn.length > 0 &&
                  data?.banner_btn?.map((btn, key) =>
                    btn?.link ? (
                      <Link
                        key={btn?.id}
                        href={`${btn?.link}`}
                        className={`${key % 2 === 0 && 'mr-3'} inline-block btnleftright mt-0 bg-[#0050D5] border-[1px] border-[#0050D5] font-[500] lg:text-[20px] text-[14px] text-[#fff] rounded-[4px] relative overflow-hidden lg:px-10 px-5 py-2`}
                      >
                        <span className="relative z-[5] transition duration-300 ease-in-out">
                          {btn?.text}
                        </span>
                      </Link>
                    ) : (
                      <button
                        key={btn?.id}
                        onClick={() => setModalCall(btn?.text)}
                        className={`${key % 2 === 0 && 'mr-3'} btncolorleftright inline-block border-[1px] border-[#fff] text-[#fff] py-2 lg:px-10 px-5 lg:text-[20px] text-[14px] font-[500] relative overflow-hidden`}
                      >
                        <span className="relative z-[5] transition duration-300 ease-in-out">
                          {btn?.text}
                        </span>
                      </button>
                    )
                  )}
              </div>

              {data?.services.length > 0 && (
                <div className="grid md:grid-cols-3 grid-cols-1 gap-6 md:mt-10 mt-6 md:mb-0 mb-5">
                  {data?.services?.map(data => (
                    <div key={data?.id}>
                      <h6 className="text-[18px] text-[#FFFFFF] font-[600]">
                        {data?.title}
                      </h6>
                      <p className="text-[13px] font-[400] text-[#fff]">
                        {data?.description}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            {windowWidth > 1023 && clientlogo && (
              <ContactTrustedClient clientlogo={clientlogo} />
            )}
          </div>
          <div
            className={`col-span-6`}
            style={{
              background: `linear-gradient(130deg,  #000815 0%, #000815 20%, #000815 70%, rgba(134, 3, 189, 0.51) 100%)`,
            }}
          >
            <ContactForm title={data?.h1_black} />
            {windowWidth < 1024 && clientlogo && (
              <ContactTrustedClient clientlogo={clientlogo} />
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}
